export default "__VITE_ASSET__dfc00773__"